<template>
  <div id="app">
    <h1>{{ $route.meta.title }}</h1>
    <Navigation></Navigation>
    <router-view/>
    <Footer></Footer>
  </div>
</template>

<style>
h1 {
  display: none;
}
</style>

<script>
import Navigation from '@/components/Navigation.vue'
import Footer from '@/components/Footer.vue'

export default {
  components: {
    Navigation,
    Footer
  }
}
</script>
